<template>
  <div>
    <b-row>
      <b-container>
        <div class="container">
          <b-col>
            <div class="div-title">
              <h5 class="title">{{ title }}</h5>
            </div>
          </b-col>
        </div>
      </b-container>
    </b-row>

    <details open>
      <summary>
        Recursos Humanos
      </summary>
      <div class="data">
        <Buttons />
        <div class="button-comparate">
          <b-button class="btn-comparate" @click="redirectHumanos">
            Comparar
          </b-button>
        </div>
        <div class="alert-comparator" v-if="showErrorRRHH">
          <Alert :text="errorText" />
        </div>
      </div>
    </details>

    <details>
      <summary>
        Recursos Financieros
      </summary>
      <div class="data">
        <ButtonsFinanciera />
        <div class="button-comparate">
          <b-button class="btn-comparate" @click="redirectFinancieros">
            Comparar
          </b-button>
        </div>
        <div class="alert-comparator" v-if="showErrorRRFF">
          <Alert :text="errorText" />
        </div>
      </div>
    </details>
  </div>
</template>

<script>
import Buttons from "./Buttons.vue";
import ButtonsFinanciera from "./ButtonsFinanciera.vue";
import Alert from "../../../components/error/Alert.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    Buttons,
    ButtonsFinanciera,
    Alert,
  },
  data() {
    return {
      title: "Y ahora elige qué ámbitos del desempeño quieres comparar:",
      errorText:
        "Debe seleccionar ambos servicios y por lo menos un (1) campo a comparar.",
      showErrorRRHH: false,
      showErrorRRFF: false,
    };
  },
  computed: {
    ...mapGetters([
      "rrhhComparator",
      "rrffComparator",
      "comparatorService_1",
      "comparatorService_2",
    ]),
  },
  methods: {
    redirectHumanos: function() {
      const verify = this.rrhhComparator;
      if (this.comparatorService_1 && this.comparatorService_2) {
        if (
          verify.genero ||
          verify.edad ||
          verify.tipo_contrato ||
          verify.estamento ||
          verify.permanencia
        ) {
          this.$router.push({ name: "comparator" });
          this.showErrorRRHH = false;
          return;
        }
      }
      this.showErrorRRHH = true;
      setTimeout(() => {
        this.showErrorRRHH = false;
      }, 5000);
    },
    redirectFinancieros: function() {
      const verify = this.rrffComparator;
      if (this.comparatorService_1 && this.comparatorService_2) {
        if (verify.comportamiento || verify.resultado) {
          this.$router.push({ name: "ComparateFinanciera" });
          this.showErrorRRHH = false;
          return;
        }
      }
      this.showErrorRRFF = true;
      setTimeout(() => {
        this.showErrorRRFF = false;
      }, 5000);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Fira+Sans:wght@300;400;600&display=swap");

*,
*:after,
*:before {
  box-sizing: border-box;
}

.div-title {
  margin-top: 50px;
  margin-bottom: 20px;
}
.title {
  /* font-size: 20px; */
  color: #052333;
  margin-left: 50px;
  font-weight: 600;
}

.row {
  margin: 0;
}

.data {
  justify-content: center;
  align-items: center;
}

:root {
  font-size: 16px;
}

body {
  font-family: "Fira Sans", sans-serif;
  line-height: 1.5;
  min-height: 100vh;
  font-size: 1.25rem;
}

*:focus {
  outline: none;
}

body > div {
  width: 90%;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5rem;
  margin-bottom: 5rem;
}

data {
  padding: 2.5em;
}

data > * + * {
  margin-top: 1.5em;
}

details + details {
  margin-top: 20px;
  margin-bottom: 20px;
}

summary::-webkit-details-marker {
  display: none;
}

summary {
  padding: 0.75em 1em;
  cursor: pointer;
  position: relative;
  padding-left: calc(1.75rem + 0.75rem + 0.75rem);
  background: rgb(36, 198, 171, 0.4);
  font-weight: 600;
}

details[open] summary {
  background: rgb(36, 198, 171, 0.4);
}

summary:hover {
  background: rgb(36, 198, 171, 0.4);
}

a {
  color: inherit;
  font-weight: 600;
  text-decoration: none;
  box-shadow: 0 1px 0 0;
}

a:hover {
  box-shadow: 0 3px 0 0;
}

.button-comparate {
  display: flex;
  justify-content: center;
}

.btn-comparate {
  background: #4f52ff;
  border: none;
  color: #fff;
}

.btn-comparate:hover {
  background: #4f52ff;
}

@import url("https://fonts.googleapis.com/css2?family=Fira+Sans:wght@300;400;600&display=swap");
code {
  font-family: "Fira Sans", sans-serif;
  font-weight: 600;
}

.title {
  text-align: center;
}

.div-title {
  margin-top: 20px;
  margin-bottom: 10px;
}

.container {
  margin-top: 10px;
  margin-bottom: 20px;
}

.alert-comparator {
  display: flex;
  justify-content: center;
}

@media screen and (max-width: 520px) {
  .title {
    font-size: 12px;
  }
}
</style>
